import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "validate-address-dialog py-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-0 h4 px-3" }, "Address Validation"),
  /*#__PURE__*/_createElementVNode("hr")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "px-3 py-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The patient's primary address will be used for documentation, claims and verifying location on a mobile device. Suggested changes are marked in "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "red"),
  /*#__PURE__*/_createTextVNode(". ")
], -1 /* HOISTED */)
const _hoisted_6 = { class: "row g-0" }
const _hoisted_7 = { class: "col-12 col-sm-6 pe-sm-2" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Original Address", -1 /* HOISTED */)
const _hoisted_11 = { class: "card-text" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_17 = { class: "col-12 col-sm-6" }
const _hoisted_18 = { class: "card axxess-intelligence-border" }
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Validated Address", -1 /* HOISTED */)
const _hoisted_21 = { class: "card-text" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, "Please enter Address to Validate.", -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_31 = { class: "d-flex justify-content-end px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.validAddress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("address", null, [
                        _createTextVNode(_toDisplayString(_ctx.options.originalAddress.addressLine1) + " ", 1 /* TEXT */),
                        (_ctx.options.originalAddress?.addressLine2?.length > 0)
                          ? (_openBlock(), _createElementBlock("br", _hoisted_12))
                          : _createCommentVNode("v-if", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.options.originalAddress.addressLine2) + " ", 1 /* TEXT */),
                        _hoisted_13,
                        _createTextVNode(" " + _toDisplayString(_ctx.options.originalAddress.city) + " ", 1 /* TEXT */),
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString(_ctx.options.originalAddress.state) + " " + _toDisplayString(_ctx.options.originalAddress.zipCode ? "," : "") + " " + _toDisplayString(_ctx.formatZipCode(_ctx.options.originalAddress.zipCode)) + " ", 1 /* TEXT */),
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(_ctx.options.originalAddress.county) + " ", 1 /* TEXT */),
                        _hoisted_16,
                        _createTextVNode(" " + _toDisplayString(_ctx.originalAddressCountry), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("address", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(`${_ctx.checkEqualAddress(
                                                _ctx.options.originalAddress.addressLine1,
                                                _ctx.options.updatedAddress.addressLine1
                                            )}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.addressLine1), 3 /* TEXT, CLASS */),
                        (_ctx.options.updatedAddress.addressLine2.length > 0)
                          ? (_openBlock(), _createElementBlock("br", _hoisted_22))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("span", {
                          class: _normalizeClass(`${_ctx.checkEqualAddress(
                                                _ctx.options.originalAddress.addressLine2,
                                                _ctx.options.updatedAddress.addressLine2
                                            )}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.addressLine2), 3 /* TEXT, CLASS */),
                        _hoisted_23,
                        _createElementVNode("span", {
                          class: _normalizeClass(`${_ctx.checkEqualAddress(
                                                _ctx.options.originalAddress.city,
                                                _ctx.options.updatedAddress.city
                                            )}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.city), 3 /* TEXT, CLASS */),
                        _hoisted_24,
                        _createElementVNode("span", {
                          class: _normalizeClass(`${_ctx.checkEqualAddress(
                                                _ctx.options.originalAddress.state,
                                                _ctx.options.updatedAddress.state
                                            )}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.state), 3 /* TEXT, CLASS */),
                        _createTextVNode(" " + _toDisplayString(_ctx.options.updatedAddress.zipCode ? "," : "") + " ", 1 /* TEXT */),
                        _createElementVNode("span", {
                          class: _normalizeClass(`${_ctx.checkEqualAddress(
                                                _ctx.options.originalAddress.zipCode,
                                                _ctx.options.updatedAddress.zipCode
                                            )}`)
                        }, _toDisplayString(_ctx.formatZipCode(_ctx.options.updatedAddress.zipCode)), 3 /* TEXT, CLASS */),
                        _hoisted_25,
                        _createElementVNode("span", {
                          class: _normalizeClass(`${_ctx.checkEqualAddress(
                                                _ctx.options.originalAddress.county,
                                                _ctx.options.updatedAddress.county
                                            )}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.county), 3 /* TEXT, CLASS */),
                        _hoisted_26,
                        _createElementVNode("span", {
                          class: _normalizeClass(`${
                                                _ctx.originalAddressCountry &&
                                                _ctx.updatedAddressCountry &&
                                                _ctx.originalAddressCountry === _ctx.updatedAddressCountry
                                                    ? ''
                                                    : 'text-danger'
                                            }`)
                        }, _toDisplayString(_ctx.updatedAddressCountry), 3 /* TEXT, CLASS */)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.validAddress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
        : _createCommentVNode("v-if", true)
    ]),
    _hoisted_30,
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light border border-secondary me-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
      }, _toDisplayString(_ctx.validAddress ? "Keep Current Address" : "Cancel"), 1 /* TEXT */),
      (_ctx.validAddress)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary border border-primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.success()))
          }, " Use Validated Address "))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}